export const ADDITIONAL_VALUES_BREADCRUMBS = [
  {
    children: 'Dashboard',
    href: `/dashboard`
  },
  {
    children: 'Additional value'
  }
]
